import * as React from 'react';
import { Tooltip, TooltipToggle } from 'telia-front-react';
export const EventContentTooltip = ({ content, index }) => {
    if (!content) {
        return null;
    }
    if (content.length > 80) {
        return (React.createElement(React.Fragment, null,
            React.createElement(TooltipToggle, { id: `content-tooltip-toggle-${index}` }, content.substring(0, 75).concat('...')),
            React.createElement(Tooltip, { referenceElement: `#content-tooltip-toggle-${index}`, size: "large", fixedWidth: false }, content)));
    }
    else {
        return React.createElement(React.Fragment, null, content);
    }
};
export default EventContentTooltip;
